module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0090.jpg?v=812e8786";